<svg
  class="brand__logo"
  viewBox="0 0 109.73 22"
  aria-hidden="true"
  focusable="false"
>
  <path class="brand__mark" d="M0 2H11L15 4L11 6H0Z"></path>
  <path
    class="brand__mark brand__mark--accent"
    d="M0 9H18L22 11L18 13H0Z"
  ></path>
  <path class="brand__mark" d="M0 16H7L11 18L7 20H0Z"></path>
  <text
    class="brand__word"
    x="28"
    y="15.851"
    font-size="13.86"
    letter-spacing="-0.3604"
  >
    Księgowskaz
  </text>
</svg>
<span class="brand__module">Kadry</span>
